import { Component, Inject, Input } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NotificationService } from "src/app/services/notification.service";
import { AddPrelungireComponent } from "../add-prelungire/add-prelungire.component";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";
import { RegistruService } from "../registru.service";
import { finalize } from "rxjs";
import { IFieldProps } from "../registru.interface";

@Component({
    selector: 'app-edit-field',
    templateUrl: './edit-field.component.html',
    styleUrls: ['./edit-field.component.scss']
})
export class EditFieldComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;
    token!: string;
    isLoading = false;

    fieldName = "";
    fieldParam = "";

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { id: number, field: IFieldProps },
        private dialogRef: MatDialogRef<AddPrelungireComponent>,
        private notificationService: NotificationService,
        private registruService: RegistruService
    ) {
        this.fieldName = data.field.fieldName;
        this.fieldParam = data.field.fieldParam;
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    form: FormGroup = new FormGroup({
        field: new FormControl(this.data.field.fieldData, Validators.required),
    });

    submitForm() {
        this.isLoading = true;

        const { field } = this.form.value;

        let payload = {
            [this.fieldParam]: field,
        };

        this.registruService
            .updateField(this.data.id, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (response: any) => {
                    if (response) {
                        this.dialogRef?.close({
                            success: true,
                        });
                    }
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
